import React, { useState } from 'react';
import { MicIcon } from 'lucide-react';
import BackButton from '../../../components/UI/BackButton';
import { useNarratorShelf } from './useNarratorShelf';
import { SearchFilters } from './SearchFilters';
import { ItemDisplay, CoverCarousel, NarratorBookInfoModal } from './ItemDisplay';
import { BookHoverCard } from './BookHoverCard';
const NarratorShelf = () => {
  const {
    category,
    searchTerm,
    setSearchTerm,
    showFilters,
    setShowFilters,
    selectedGenre,
    setSelectedGenre,
    viewMode,
    setViewMode,
    sortOption,
    setSortOption,
    darkMode,
    hoveredBookId,
    setHoveredBookId,
    mousePosition,
    booksPerShelf,
    shelfContainerRef,
    selectedWrittenAuthor,
    setSelectedWrittenAuthor,
    genres,
    sortedBooks,
    bookShelves,
    seriesData,
    writtenAuthors,
    filteredAuthorBooks,
    navigateToCategory,
    navigateToEdit,
    navigate
  } = useNarratorShelf();
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const [selectedBook, setSelectedBook] = useState<any | null>(null);
  return <div className={`min-h-screen ${darkMode ? 'bg-gray-900 text-gray-100' : 'bg-gray-50 text-gray-900'} py-8`} data-id="element-20225" data-mp="3t0e5mwe5vkfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20226" data-mp="3o2cfjribikup">
        {/* Header */}
        <div className="mb-6" data-id="element-20227" data-mp="3j3hv6l4pco8h">
          <div className="mb-3" data-id="element-20228" data-mp="3j4klaqu7amnc">
            <BackButton data-id="element-20229" data-mp="kkkoqgfx46y3" />
          </div>
          <h1 className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-20230" data-mp="kjj4bld0i83p">
            Narrator Portfolio
          </h1>
          <p className={`mt-1 text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-20231" data-mp="auhn5ruqdko5">
            Showcase your narrated audiobooks
          </p>
        </div>

        {/* Tabs */}
        <div className={`mb-6 flex space-x-1 overflow-x-auto border-b ${darkMode ? 'border-gray-700' : 'border-gray-300'}`} data-id="element-20232" data-mp="13btx2mdycpo3">
          <button onClick={() => navigate('/narrator/shelf')} className={`py-2 px-4 font-medium whitespace-nowrap ${!category ? `border-b-2 border-purple-600 ${darkMode ? 'text-purple-400' : 'text-purple-600'}` : `${darkMode ? 'text-gray-400 hover:text-purple-400' : 'text-gray-600 hover:text-purple-600'}`}`} data-id="element-20233" data-mp="yjaok3u4gkq5">
            All Titles
          </button>
          <button onClick={() => navigateToCategory('series')} className={`py-2 px-4 font-medium whitespace-nowrap ${category === 'series' ? `border-b-2 border-purple-600 ${darkMode ? 'text-purple-400' : 'text-purple-600'}` : `${darkMode ? 'text-gray-400 hover:text-purple-400' : 'text-gray-600 hover:text-purple-600'}`}`} data-id="element-20234" data-mp="2o065lp7ecid4">
            By Series
          </button>
          <button onClick={() => navigateToCategory('author')} className={`py-2 px-4 font-medium whitespace-nowrap ${category === 'author' ? `border-b-2 border-purple-600 ${darkMode ? 'text-purple-400' : 'text-purple-600'}` : `${darkMode ? 'text-gray-400 hover:text-purple-400' : 'text-gray-600 hover:text-purple-600'}`}`} data-id="element-20235" data-mp="253eptpr2cldt">
            By Author
          </button>
          <button onClick={() => navigateToCategory('special')} className={`py-2 px-4 font-medium whitespace-nowrap ${category === 'special' ? `border-b-2 border-purple-600 ${darkMode ? 'text-purple-400' : 'text-purple-600'}` : `${darkMode ? 'text-gray-400 hover:text-purple-400' : 'text-gray-600 hover:text-purple-600'}`}`} data-id="element-20236" data-mp="8hx3a2epjp0t">
            Special Projects
          </button>
        </div>

        {/* Filters */}
        <SearchFilters searchTerm={searchTerm} setSearchTerm={setSearchTerm} showFilters={showFilters} setShowFilters={setShowFilters} selectedGenre={selectedGenre} setSelectedGenre={setSelectedGenre} viewMode={viewMode} setViewMode={setViewMode} sortOption={sortOption} setSortOption={setSortOption} genres={genres} darkMode={darkMode} data-id="element-20237" data-mp="156cstyhthydx" />

        {/* Author Tabs (only on Author tab) */}
        {category === 'author' && <div className={`mb-4 flex space-x-2 overflow-x-auto ${darkMode ? 'text-gray-300' : 'text-gray-700'}`} data-id="element-20238" data-mp="39b37nenyiqku">
            {writtenAuthors.map(author => <button key={author} onClick={() => setSelectedWrittenAuthor(author)} className={`py-1 px-3 rounded-full text-sm whitespace-nowrap ${selectedWrittenAuthor === author ? `bg-purple-100 text-purple-700 ${darkMode ? 'bg-opacity-80' : ''}` : `${darkMode ? 'bg-gray-800 hover:bg-gray-700' : 'bg-gray-100 hover:bg-gray-200'}`}`} data-id="element-20239" data-mp="3ic1dm2hyh862">
                {author === 'all' ? 'All Authors' : author}
              </button>)}
          </div>}

        {/* Content Area */}
        <div ref={shelfContainerRef} data-id="element-20240" data-mp="26y5tefc7297z">
          {/* All Titles / Special Projects */}
          {(!category || category === 'special') && <ItemDisplay books={sortedBooks} viewMode={viewMode} darkMode={darkMode} booksPerShelf={booksPerShelf} hoveredBookId={hoveredBookId} setHoveredBookId={setHoveredBookId} mousePosition={mousePosition} title={category === 'special' ? 'Special Projects' : 'All Audiobooks'} data-id="element-20241" data-mp="1zdbsl5co77pa" />}

          {/* By Series */}
          {category === 'series' && <>
              {Object.entries(seriesData).map(([seriesName, books]) => <div key={seriesName} className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-md p-6 mb-8`} data-id="element-20242" data-mp="16qilm58otc6u">
                  <h2 className={`text-xl font-semibold mb-6 ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-20243" data-mp="xo9fdrkgc4z9">
                    {seriesName}
                  </h2>
                  {viewMode === 'spine' ? <ItemDisplay books={books} viewMode="spine" darkMode={darkMode} booksPerShelf={booksPerShelf} hoveredBookId={hoveredBookId} setHoveredBookId={setHoveredBookId} mousePosition={mousePosition} showShelves={false} data-id="element-20244" data-mp="j4yhuwuybyzs" /> : <CoverCarousel books={books} darkMode={darkMode} onBookClick={book => setSelectedBook(book)} onHoverEnter={id => !isMobile && setHoveredBookId(id)} onHoverLeave={() => setHoveredBookId(null)} data-id="element-20245" data-mp="16r53ilxatd8h" />}
                </div>)}
            </>}

          {/* By Author */}
          {category === 'author' && <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-md p-6 mb-8`} data-id="element-20246" data-mp="3a81mlq2kqoci">
              <h2 className={`text-xl font-semibold mb-6 ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-20247" data-mp="359qdjhk3shvc">
                {selectedWrittenAuthor === 'all' ? 'All Authors' : `Written by ${selectedWrittenAuthor}`}
              </h2>

              {viewMode === 'spine' ? <ItemDisplay books={filteredAuthorBooks} viewMode="spine" darkMode={darkMode} booksPerShelf={booksPerShelf} hoveredBookId={hoveredBookId} setHoveredBookId={setHoveredBookId} mousePosition={mousePosition} data-id="element-20248" data-mp="2mbns1cqrl32a" /> : selectedWrittenAuthor !== 'all' ? <CoverCarousel books={filteredAuthorBooks} darkMode={darkMode} onBookClick={book => setSelectedBook(book)} onHoverEnter={id => !isMobile && setHoveredBookId(id)} onHoverLeave={() => setHoveredBookId(null)} data-id="element-20249" data-mp="amd4cfpphql0" /> : <ItemDisplay books={filteredAuthorBooks} viewMode="cover" darkMode={darkMode} booksPerShelf={booksPerShelf} hoveredBookId={hoveredBookId} setHoveredBookId={setHoveredBookId} mousePosition={mousePosition} showShelves={false} data-id="element-20250" data-mp="13mjial7zzjxf" />}
            </div>}

          {/* Empty State */}
          {sortedBooks.length === 0 && <div className={`text-center py-12 ${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-md`} data-id="element-20251" data-mp="3p402946cbzzp">
              <MicIcon className={`h-12 w-12 ${darkMode ? 'text-gray-600' : 'text-gray-400'} mx-auto mb-4`} data-id="element-20252" data-mp="3t63g1zghfgo5" />
              <h3 className={`text-lg font-medium mb-2 ${darkMode ? 'text-gray-200' : 'text-gray-900'}`} data-id="element-20253" data-mp="3lnnhbia22rmi">
                No audiobooks found
              </h3>
              <p className={darkMode ? 'text-gray-400' : 'text-gray-500'} data-id="element-20254" data-mp="3btwq45mjo334">
                Try adjusting your search or filters
              </p>
            </div>}
        </div>
      </div>

      {/* Global Popup for Carousel Clicks */}
      {selectedBook && <NarratorBookInfoModal book={selectedBook} darkMode={darkMode} onClose={() => setSelectedBook(null)} onEdit={navigateToEdit} data-id="element-20255" data-mp="3gpko0ebbp91" />}
    </div>;
};
export default NarratorShelf;